import TripReviewGiftFormContainer from './trip-review-gift-form-container';

export default TripReviewGiftFormContainer;
